import React, { useState, useEffect } from "react";
import * as firebase from "firebase";
import { Layout, Row, Col, Typography, Button, Modal } from "antd";
import { Redirect } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import RaffleForm from "../Components/RaffleForm";

const { Title } = Typography;
const { Header, Content, Footer } = Layout;
const { confirm } = Modal;

export default function RafflePage({ history }) {
  const [user, setUser] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);

  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imageAsFile, setImageAsFile] = useState(null);

  const [raffles, setRaffles] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    let user = localStorage.getItem("User");
    if (user) {
      setLoggedIn(true);
      setUser(JSON.parse(user));
      console.log(JSON.parse(user));
    } else setLoggedIn(false);
  }, []);

  const _addRaffle = () => {
    if (name === "") return alert("Enter raffle name");
    if (description === "") return alert("Enter raffle description");
    if (imageAsFile === null) return alert("Please upload raffle image");
  };

  const _updateRaffle = () => {
    if (name === "") return alert("Enter raffle name");
    if (description === "") return alert("Enter raffle description");
  };

  const onChange = (value, key) => {
    switch (key) {
      case "name":
        setName(value);
        break;
      case "description":
        setDescription(value);
        break;
      default:
        break;
    }
  };

  const onFileUpload = (e) => {
    console.log(e.file);
    setImageAsFile(e.file);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const editDeck = (deck) => {
    const { name, description } = deck;
    setSelectedCard(deck);
    setName(name);
    setDescription(description);
    setEditMode(true);
  };

  const onDeleteDeck = async () => {
    confirm({
      title: "Are you sure delete this deck?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        // deleteFileFromStorage(selectedCard.imagePath).then(() => {
        // deleteDeck(selectedCard.id).then(() => {
        //   setEditMode(false);
        //   const temp = [...decks];
        //   const index = temp.findIndex((el) => el.id === selectedCard.id);
        //   temp.splice(index, 1);
        //   setRaffles(temp);
        //   setSelectedCard(null);
        //   setName("");
        //   setDescription("");
        //   setImageAsFile(null);
        //   message.success("Deck Deleted!");
        //   setLoading(false);
        // });
        // });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const cancelEditMode = () => {
    setEditMode(false);
    setSelectedCard(null);
    setName("");
    setDescription("");
    setImageAsFile(null);
  };

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // Sign-out successful.
        localStorage.clear();
        setLoggedIn(false);
      })
      .catch(function (error) {
        // An error happened.
        console.error(error);
      });
  };

  if (loggedIn === null) return <div />;
  if (loggedIn === false) return <Redirect to={"/"} />;

  return (
    <Layout className="layout">
      <Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title level={3} style={{ paddingTop: "1%" }} className="header">
          Dashboard
          <Button
            type="link"
            style={{ marginLeft: 20 }}
            onClick={() => history.push("/dashboard")}
          >
            Home
          </Button>
        </Title>
        <Button onClick={logout}>Logout</Button>
      </Header>
      <Content style={{ padding: "0 50px" }}>
        <div className="site-layout-content">
          <Row>
            <Col span={18}>
              <RaffleForm
                loading={loading}
                onSubmit={editMode ? _updateRaffle : _addRaffle}
                onChange={onChange}
                onFileUpload={onFileUpload}
                editMode={editMode}
                onCancelEditMode={cancelEditMode}
                onDeletePress={onDeleteDeck}
              />
            </Col>
          </Row>
        </div>
      </Content>
      <Footer style={{ textAlign: "center" }}></Footer>
    </Layout>
  );
}
